<template>
  <nav v-if="pageCount > 1" class="compact-pagination" aria-label="Pagination">
    <template v-for="item in items">
      <span
        v-if="item.page === null"
        :key="item.key"
        class="compact-pagination__ellipsis"
        aria-hidden="true"
      >
        &hellip;
      </span>
      <button
        v-else
        :key="item.key"
        type="button"
        class="btn compact-pagination__button"
        :class="{ 'compact-pagination__button--active': item.page === normalizedCurrentPage }"
        :aria-current="item.page === normalizedCurrentPage ? 'page' : null"
        :aria-label="`Page ${item.page}`"
        @click="$emit('change', item.page)"
      >
        {{ item.page }}
      </button>
    </template>
  </nav>
</template>

<script>
export default {
  name: 'CompactPagination',
  props: {
    pages: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: [Number, String],
      default: 1
    }
  },
  computed: {
    pageCount() {
      return this.pages.length;
    },
    normalizedCurrentPage() {
      const current = Number(this.currentPage) || 1;
      return Math.min(Math.max(current, 1), Math.max(this.pageCount, 1));
    },
    items() {
      const total = this.pageCount;

      if (total <= 7) {
        return Array.from({ length: total }, (_, index) => ({
          key: `page-${index + 1}`,
          page: index + 1
        }));
      }

      const current = this.normalizedCurrentPage;
      const pages = [
        1,
        2,
        3,
        current - 1,
        current,
        current + 1,
        total - 2,
        total - 1,
        total
      ]
        .filter(page => page >= 1 && page <= total)
        .filter((page, index, values) => values.indexOf(page) === index)
        .sort((a, b) => a - b);

      const items = [];
      pages.forEach((page, index) => {
        if (index > 0 && page - pages[index - 1] > 1) {
          items.push({ key: `ellipsis-${pages[index - 1]}-${page}`, page: null });
        }
        items.push({ key: `page-${page}`, page });
      });

      return items;
    }
  }
};
</script>

<style scoped>
.compact-pagination {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.compact-pagination__button {
  min-width: 2.25rem;
  border: 1px solid #dee2e6;
  background: #fff;
}

.compact-pagination__button:hover {
  border-color: #534dff;
}

.compact-pagination__button--active {
  border-color: #534dff;
  color: #534dff;
  font-weight: 600;
}

.compact-pagination__ellipsis {
  min-width: 1.5rem;
  color: #6c757d;
  text-align: center;
  user-select: none;
}
</style>
